import React, { FC } from 'react';
import { Box, Container, Grid, makeStyles, Theme, Typography, useMediaQuery } from '@material-ui/core';
import AboutDescription from './AboutDescription';
import { animated } from 'react-spring';

interface AboutDescriptionSectionProps {
  headTitle: string;
  textContentList: Array<{ title: string; description: string }>;
}

const useStyles = makeStyles((theme: Theme) => ({
  box: {
    position: 'relative',
    paddingTop: theme.spacing(25),
    marginBottom: theme.spacing(15),
    [theme.breakpoints.up('md')]: {
      marginBottom: theme.spacing(20),
      marginTop: theme.spacing(4),
      paddingTop: 0,
    },
  },
  title: {
    fontSize: 22,
    fontWeight: 'bold',
    lineHeight: 1.3,
    [theme.breakpoints.up('sm')]: {
      fontSize: 38,
    },
    [theme.breakpoints.up('md')]: {
      fontSize: 48,
      lineHeight: 1.2,
    },
  },
  titleBox: {
    background: theme.palette.primary.main,
    color: theme.palette.text.secondary,
    padding: theme.spacing(4, 4, 8),
    alignItems: 'flex-end',
    justifyContent: 'flex-start',
    display: 'flex',
    margin: 0,
    zIndex: 1,
    width: '100%',
    maxWidth: 180,
    minHeight: 147,
    position: 'absolute',
    left: 0,
    top: 0,
    [theme.breakpoints.up('sm')]: {
      position: 'sticky',
      top: '20%',
      maxWidth: '100%',
      margin: 0,
      minHeight: 200,
    },
    [theme.breakpoints.up('md')]: {
      top: '30%',
      minHeight: 252,
    },
    [theme.breakpoints.up('lg')]: {
      position: 'relative',
      top: theme.spacing(-5),
    },
  },
  contentBox: {
    zIndex: 1,
  },
}));

const AboutDescriptionSection: FC<AboutDescriptionSectionProps> = ({ headTitle, textContentList }) => {
  const classes = useStyles();
  const isSmallUp = useMediaQuery((theme: Theme) => theme.breakpoints.up('sm'));
  const isLargeUp = useMediaQuery((theme: Theme) => theme.breakpoints.up('lg'));

  return (
    <Box className={classes.box}>
      <Container maxWidth={false} fixed>
        <Grid container spacing={isSmallUp ? 10 : 0} justify={isLargeUp ? 'space-between' : 'center'}>
          <Grid item lg={3} md={4} sm={5}>
            <animated.div data-aos="fade-up" data-aos-delay="200" className={classes.titleBox}>
              <Typography className={classes.title}>
                <span>{headTitle}</span>
              </Typography>
            </animated.div>
          </Grid>
          <Grid item lg={9} md={8} sm={7} className={classes.contentBox}>
            {!!textContentList.length && (
              <Grid container spacing={5} justify="center">
                {textContentList.map((stat, index) => (
                  <Grid xs={12} lg={4} item key={index}>
                    <animated.div data-aos="fade-up" data-aos-delay={(index + 2) * 200}>
                      <AboutDescription postTitle={stat.title} postDescription={stat.description} />
                    </animated.div>
                  </Grid>
                ))}
              </Grid>
            )}
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default AboutDescriptionSection;
